@if (stepService.ready.value) {
  <section class="container">
    <fuse-sidebar class="sidebar side-navigation" name="page-sidebar" position="left" lockedOpen="gt-md">
      <nav>
        <!-- disattivato momentaneamente su richiesta di Francesco
        <ng-container *ngIf='record && record.active_status && record.publish_on_web'>
          <a class="page-product-btn" mat-flat-button [href]='appService.getBaseServerAddressRoot() + "/preview/d/"+record.domain.id+"/products/"+record.code+"/"+record.id' target="_blank">Pagina prodotto</a>
        </ng-container>
        -->
        <app-custom-stepper [selectedIndex]='stepperIndex' #customStepper (selectionChange)='stepChange($event)'>
          @for (computedStep of computedSteps; track trackStepBy($index, computedStep)) {
            <div customCdkStep
              [completed]='record !== null'
              [computedStep]='computedStep'
            ></div>
          }
        </app-custom-stepper>
      </nav>
    </fuse-sidebar>
    <div class="step-container step-location">
      <div class="header accent p-24 fx-row fx-justify-start fx-items-center fx-hide-gt-md">
        <button mat-icon-button (click)="toggleSidebar('page-sidebar')" class="sidebar-toggle mr-8 fx-hide-gt-md">
          <mat-icon>menu</mat-icon>
        </button>
        <div>
          <h2 class="m-0">{{stepViewConfig.title | translate}}</h2>
          @if (record && subtitle) {
            <span class='mt-0 h4 secondary-text'>{{subtitle | translate}}</span>
          }
        </div>
      </div>
      <div class="content p-24">
        <mat-tab-group class='tab-hidden-header' [selectedIndex]='stepIndex'>
          @for (stepConfig of steps; track stepConfig; let i = $index) {
            <mat-tab>
              <ng-template matTabContent>
                <h2 class="step-title">{{stepConfig.title}}</h2>
                @switch (stepConfig?.component) {
                  <!-- TRIP PACKAGES SMART INTERFACE STEPS -->
                  @case ("product-name-step") {
                    <product-name-step
                      [stepConfig]='stepConfig'
                      [stepper]='customStepper'
                      (nextStep)='customStepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></product-name-step>
                  }
                  @case ("resell-product-name-step") {
                    <resell-product-name-step
                      [stepConfig]='stepConfig'
                      [stepper]='customStepper'
                      (nextStep)='customStepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></resell-product-name-step>
                  }
                  @case ("trip-destination-step") {
                    <trip-destination-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></trip-destination-step>
                  }
                  @case ("resell-trip-destination-step") {
                    <resell-trip-destination-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></resell-trip-destination-step>
                  }
                  @case ("smart-interface-i18n-form-step") {
                    <smart-interface-i18n-form-step
                      [stepConfig]='stepConfig'
                      [fileterFields]='stepConfig.options.fieldsMap'
                      (nextStep)='customStepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></smart-interface-i18n-form-step>
                  }
                  @case ("resell-smart-interface-i18n-form-step") {
                    <resell-smart-interface-i18n-form-step
                      [stepConfig]='stepConfig'
                      [fileterFields]='stepConfig.options.fieldsMap'
                      (nextStep)='customStepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></resell-smart-interface-i18n-form-step>
                  }
                  @case ("common-i18n-data-viewer-step") {
                    <common-i18n-data-viewer-step
                      [stepConfig]='stepConfig'
                      [formConfig]='stepConfig.options.formConfig'
                      (nextStep)='stepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></common-i18n-data-viewer-step>
                  }
                  @case ("trip-package-trip-facilities") {
                    <trip-package-trip-facilities
                      [parentDatasetRS]='datasetRS'
                      [parentDatasetACS]='datasetACS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                      (nextStep)='customStepper.next()'
                    ></trip-package-trip-facilities>
                  }
                  @case ("resell-trip-package-trip-facilities") {
                    <resell-trip-package-trip-facilities
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                      (nextStep)='customStepper.next()'
                    ></resell-trip-package-trip-facilities>
                  }
                  @case ("trip-package-trip-categories") {
                    <trip-package-trip-categories
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [stepper]='customStepper'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></trip-package-trip-categories>
                  }
                  @case ("resell-trip-package-trip-categories") {
                    <resell-trip-package-trip-categories
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [stepper]='customStepper'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></resell-trip-package-trip-categories>
                  }
                  @case ("trip-package-smart-interface-media") {
                    <trip-package-smart-interface-media
                      [parentDatasetRS]='datasetRS'
                      [parentDatasetACS]='datasetACS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='customStepper.next()'>
                    </trip-package-smart-interface-media>
                  }
                  @case ("resell-trip-package-smart-interface-media") {
                    <resell-trip-package-smart-interface-media
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='customStepper.next()'>
                    </resell-trip-package-smart-interface-media>
                  }
                  @case ("price-step") {
                    <price-step
                      [stepConfig]='stepConfig'
                      [stepper]='customStepper'
                      [stepIndex]='stepIndex'
                      (nextStep)='customStepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></price-step>
                  }
                  @case ("common-data-viewer-step") {
                    <common-data-viewer-step
                      [stepConfig]='stepConfig'
                      [stepIndex]='i'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='stepper.next()'
                    ></common-data-viewer-step>
                  }
                  @case ("common-blocks-step") {
                    <common-blocks-step
                      [stepConfig]='stepConfig'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [stepIndex]='i'
                      (nextStep)='stepper.next()'
                    ></common-blocks-step>
                  }
                  @case ("trip-booking-options") {
                    <trip-booking-options
                      [stepConfig]='stepConfig'
                      (nextStep)='customStepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></trip-booking-options>
                  }
                  @case ("meeting-point-unified-list-items") {
                    <meeting_point_unified_list_items
                      [stepConfig]='stepConfig'
                      (nextStep)='customStepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></meeting_point_unified_list_items>
                  }
                  @case ("availability-step") {
                    <availability-step
                      [stepConfig]='stepConfig'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [stepper]='customStepper'
                      [stepIndex]='stepIndex'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></availability-step>
                  }
                  @case ("trip-package-integrations-step-smart-interface") {
                    <integrations-step
                      [parentDatasetACS]='datasetACS'
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [hasStepState]='true'
                      [datasetCode]='"trip_packages"'
                      [integrationsDatasetCode]='"trip_package_integrations"'
                    ></integrations-step>
                  }
                  @case ("actual-trips-smart-interface") {
                    <actual-trips-smart-interface
                      (nextStep)='stepper.next()'
                      (prevStep)='stepper.previous()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></actual-trips-smart-interface>
                  }
                  <!-- PRODUCTS SMART INTERFACE STEPS -->
                  @case ("product-base-info-step") {
                    <product-base-info-step
                      [stepConfig]='stepConfig'
                      [stepper]='customStepper'
                      (nextStep)='customStepper.next()'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></product-base-info-step>
                  }
                  @case ("product-trip-categories") {
                    <product-trip-categories
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [stepper]='customStepper'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></product-trip-categories>
                  }
                  @case ("product-bundle") {
                    <product-bundle
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [stepper]='customStepper'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></product-bundle>
                  }
                  @case ("product-trip-destinations") {
                    <product-trip-destinations
                      [stepConfig]='stepConfig'
                      [stepIndex]='stepIndex'
                      [stepper]='customStepper'
                      [hasNext]='i + 1 < steps.length'
                      (nextStep)='customStepper.next()'
                      [hasPrevious]='i > 0'
                      [datasetConfig]='stepConfig.options.datasetConfig'
                    ></product-trip-destinations>
                  }
                  @case ("product-i18n-form-step") {
                    <product-i18n-form-step
                      [stepConfig]='stepConfig'
                      [fileterFields]='stepConfig.options.fieldsMap'
                      (nextStep)='customStepper.next()'
                      [parentDatasetACS]='datasetACS'
                      [parentDatasetRS]='datasetRS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                    ></product-i18n-form-step>
                  }
                  @case ("product-media") {
                    <product-media
                      [parentDatasetRS]='datasetRS'
                      [parentDatasetACS]='datasetACS'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      (nextStep)='customStepper.next()'>
                    </product-media>
                  }
                  @case ("product-advanced-blocks-step") {
                    <product-advanced-blocks-step
                      [stepConfig]='stepConfig'
                      [hasNext]='i + 1 < steps.length'
                      [hasPrevious]='i > 0'
                      [stepIndex]='i'
                      [stepper]='customStepper'
                      (nextStep)='stepper.next()'
                    ></product-advanced-blocks-step>
                  }
                  @default {
                    <div>
                      <p>Componente non configurato {{stepConfig?.component}}</p>
                    </div>
                  }
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </section>
} @else {
  <div class="white-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

